const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const resolveUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const isUploadedVideo = (u = "") => u.startsWith("/api") || /\.(mp4|webm|mov|m4v|ogv)(\?|$)/i.test(u);

export const getEmbedUrl = (u = "") => {
  if (!u) return "";
  const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vimeo = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return u;
};

// ---- Unified media items (photos + videos) ----
// A gallery item can be a plain URL string (legacy = photo) or an object
// { type: "image" | "video", url, poster }. These helpers normalize both shapes
// so the SAME gallery system works everywhere with photos and/or videos.
export const mediaItem = (x) => {
  if (x && typeof x === "object") {
    const type = x.type === "video" ? "video" : "image";
    return { type, url: x.url || "", poster: x.poster || "", frame: x.frame };
  }
  return { type: "image", url: x || "", poster: "", frame: undefined };
};

export const mediaItems = (arr) => (arr || []).map(mediaItem).filter((m) => m.url);

// First usable image (or a video's poster) — used for card covers / thumbnails.
export const galleryCover = (arr) => {
  for (const x of arr || []) {
    const m = mediaItem(x);
    if (m.type === "image" && m.url) return m.url;
    if (m.type === "video" && m.poster) return m.poster;
  }
  return "";
};

// Only the photo URLs of a gallery (for lightbox / image-only slideshows).
export const imageUrls = (arr) => mediaItems(arr).filter((m) => m.type === "image").map((m) => m.url);
